import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Container,
} from "@mui/material";
import CoinSlider from "./CoinSlider";
import EastIcon from "@mui/icons-material/East";
import AOS from "aos";
import "aos/dist/aos.css";
import { market } from "../../CommonPage/MarketFlow/TradeData";
import { useLanguage } from "../../context/LanguageContext";

// Throttle function for performance
const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

const coinData = [
  {
    symbol: "EURJPY",
    image: "/Images/slider1.png",
  },
  {
    symbol: "EURNZD",
    image: "/Images/slider2.png",
  },
  {
    symbol: "EURCAD",
    image: "/Images/slider3.png",
  },
  {
    symbol: "AUDCHF",
    image: "/Images/slider9.png",
  },



  // Add more coins as needed
];

const coinData1 = [
  {
    symbol: "AUDNZD",
    image: "/Images/slider5.png",
  },
  {
    symbol: "GBPCHF",
    image: "/Images/slider4.png",
  },
  {
    symbol: "AUDCAD",
    image: "/Images/slider6.png",
  },

  {
    symbol: "EURAUD",
    image: "/Images/slider7.png",
  },
  {
    symbol: "EURCHF",
    image: "/Images/slider8.png",
  },

  // Add more coins as needed
];


const coinData2 = [
  {
    symbol: 'LCCN4',
    label: 'AAL',
    price: '12.98',
    Change: '0',
    image: "/Images/com1.png",
  },

  {
    symbol: 'CCU4',
    price: '239.33',
    Change: '0',
    image: "/Images/com2.png",
    label: 'AAPL',
  },

  {
    symbol: 'KC0724',
    price: '199.56',
    Change: '0',
    image: "/Images/com3.png",
    label: 'AMZN',
  },



  {
    symbol: 'HGCN4',
    price: '140.57',
    Change: '0',
    image: "/Images/com4.png",
    label: 'BABA',
  },

  {
    symbol: 'CTZ4',
    price: '173.9',
    Change: '0',
    image: "/Images/com5.png",
    label: 'GOOGL',
  },



  // Add more coins as needed
];
const coinDatas2 = [
  {
    symbol: 'NatGas_N4',
    price: '261.78',
    Change: '0',
    image: "/Images/com6.png",
    label: 'IBM',
  },

  {
    symbol: 'USOIL_N4',
    price: '20.59',
    Change: '0',
    image: "/Images/com7.png",
    label: 'INTC',
  },

  {
    symbol: 'UKOIL_Q4',
    price: '71.48',
    Change: '0',
    image: "/Images/com8.png",
    label: 'KO',
  },


  {
    symbol: 'PL0724',
    price: '625.63',
    Change: '0',
    image: "/Images/com9.png",
    label: 'META',
  },

  {
    symbol: 'ZS0724',
    price: '394.13',
    Change: '0',
    image: "/Images/com10.png",
    label: 'MSFT',
  },
  // Add more coins as needed
];
const coinDatas3 = [
  {
    symbol: 'Solana',
    price: '24.07',
    Change: '0',
    image: "/Images/solana.png",

  },

  {
    symbol: 'Tron',
    price: '28.75',
    Change: '0',
    image: "/Images/TRO.png",
  },

  {
    symbol: 'Bitcoin',
    price: '76.12',
    Change: '0',
    image: "/Images/BITS.png",
  },

  {
    symbol: 'USDC',
    price: '30.03',
    Change: '0',
    image: "/Images/USDC.png",
  },
  // { symbol: "Bitcoin", price: "$3,080", image: "/Images/bit.png" },
  // { symbol: "XRP", price: "$3,080", image: "/Images/xrp.png" },
  // { symbol: "Solana", price: "$2,950", image: "/Images/solana.png" },
  // { symbol: "USDT", price: "$35,080", image: "/Images/usdt.png" },
  // Add more coins as needed
];
const coinDatass3 = [
  {
    symbol: 'Polka dot',
    price: '15.98',
    Change: '0',
    image: "/Images/POLAKA.png",
  },

  {
    symbol: 'TRC20',
    price: '33.3',
    Change: '0',
    image: "/Images/TRO.png",
  },

  {
    symbol: 'Cardano',
    price: '33.39',
    Change: '0',
    image: "/Images/CRDNO.png",
  },
  // { symbol: "Solana", price: "$2,950", image: "/Images/solana.png" },
  // { symbol: "USDT", price: "$35,080", image: "/Images/usdt.png" },
  // { symbol: "XRP", price: "$3,080", image: "/Images/xrp.png" },
  //   { symbol: "Bitcoin", price: "$3,080", image: "/Images/bit.png" },

  // Add more coins as needed
];
const coinDatas4 = [
  { symbol: "NVDA", price: "$2,950", image: "/Images/nvda.png" },
  { symbol: "APPLE", price: "$3,080", image: "/Images/apple.png" },
  { symbol: "NFLX", price: "$35,080", image: "/Images/netFlix.png" },
  { symbol: "GOOGLE", price: "$3,080", image: "/Images/google.png" },
  // Add more coins as needed
];
const coinDatass4 = [
  { symbol: "NFLX", price: "$35,080", image: "/Images/netFlix.png" },
  { symbol: "GOOGLE", price: "$3,080", image: "/Images/google.png" },
  { symbol: "APPLE", price: "$3,080", image: "/Images/apple.png" },
  { symbol: "NVDA", price: "$2,950", image: "/Images/nvda.png" },
  // Add more coins as needed
];
const coinDatas5 = [
  {
    symbol: 'CAC40_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi1.png",

  },



  {
    symbol: 'EUR50_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi3.png",
  },

  {
    symbol: 'GER30_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi4.png",
  },
  {
    symbol: 'AUS200_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi10.png",
  },

  {
    symbol: 'CA60_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi11.png",
  },
  {
    symbol: 'CH20_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi2.png",
  },
  // { symbol: "US100", price: "$35,080", image: "/Images/100.png" },
  // { symbol: "DJI", price: "$3,080", image: "/Images/dj1.png" },
  // { symbol: "NDQ", price: "$3,080", image: "/Images/ndq.png" },
  // { symbol: "US500", price: "$2,950", image: "/Images/500.png" },
  // Add more coins as needed
];
const coinDatass5 = [
  {
    symbol: 'IBEX35_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi5.png",
  },

  {
    symbol: 'IT40_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi6.png",
  },

  {
    symbol: 'NL25_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi7.png",
  },

  {
    symbol: 'NO25_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi8.png",
  },

  {
    symbol: 'UK100_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi9.png",
  },



  {
    symbol: 'HKD50_SPOT',
    price: '1.1028',
    Change: '0',
    image: "/Images/indi12.png",
  },
  // { symbol: "DJI", price: "$3,080", image: "/Images/dj1.png" },
  // { symbol: "US100", price: "$35,080", image: "/Images/100.png" },
  // { symbol: "US500", price: "$2,950", image: "/Images/500.png" },
  // { symbol: "NDQ", price: "$3,080", image: "/Images/ndq.png" },

  // Add more coins as needed
];

const coinDatas6 = [
  {
    symbol: 'BRENT',
    price: '1.1028',
    Change: '0',
    image: "/Images/ener1.png",
  },
  { symbol: "CRUDE", price: "$3,080", image: "/Images/8888.png" },

 

  {
    symbol: 'NatGas',
    price: '1.1028',
    Change: '0',
    image: "/Images/ener3.png",
  },
  // { symbol: "CRUDE", price: "$3,080", image: "/Images/8888.png" },
  // { symbol: "BRENT", price: "$35,080", image: "/Images/petrol.png" },
  // { symbol: "NATURAL", price: "$2,950", image: "/Images/blueDrop.png" },

  // Add more coins as needed
];
const coinDatass6 = [
  { symbol: "NATURAL", price: "$2,950", image: "/Images/blueDrop.png" },
  { symbol: "CRUDE", price: "$3,080", image: "/Images/8888.png" },
   {
    symbol: 'WTI',
    price: '1.1028',
    Change: '0',
    image: "/Images/ener2.png",
  },
  { symbol: "BRENT", price: "$35,080", image: "/Images/petrol.png" },

  // Add more coins as needed
];

const coinDatass7 = [
   {
            symbol: 'AAPL.OQ',
            price: '7702',
            Change: '0',
            image: "/Images/four1.png",
        },

        {
            symbol: 'AMZN.OQ',
            price: '9095',
            Change: '0',
            image: "/Images/four7.png",
        },

        {
            symbol: 'GOOGL.OQ',
            price: '225.82',
            Change: '0',
            image: "/Images/four2.png",
        },

          {
            symbol: 'IBM.N',
            price: '4.3657',
            Change: '0',
            image: "/Images/four3.png",
        },

        {
            symbol: 'INTC.OQ',
            price: '69.7',
            Change: '0',
            image: "/Images/Group (4).png",
        },
  // Add more coins as needed
];

const coinDatassS7 = [
     {
            symbol: 'META.OQ',
            price: '2.696',
            Change: '0',
            image: "/Images/four4.png",
        },

        {
            symbol: 'MSFT.OQ',
            price: '2.076',
            Change: '0',
            image: "/Images/four5.png",
        },

        {
            symbol: 'NFLX.OQ',
            price: '81.548',
            Change: '0',
            image: "/Images/slider1.png",
        },

        {
            symbol: 'NVDA.OQ',
            price: '85.948',
            Change: '0',
            image: "/Images/greeeen.png",
        },

        {
            symbol: 'PYPL.OQ',
            price: '988',
            Change: '0',
            image: "/Images/four9.png",
        },

        {
            symbol: 'TSLA.OQ',
            price: '1158.1',
            Change: '0',
            image: "/Images/four10.png",
        },
  // Add more coins as needed
];

export const Discover = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const sliderRef2 = useRef();
  const { language, translations } = useLanguage();
  const webSocketRef = useRef(null);
  const animationRef = useRef(null);

  // Optimized AOS initialization
  useEffect(() => {
    // Initialize AOS with better performance settings
    AOS.init({
      duration: 600, // Reduced duration
      once: true, // Only animate once
      offset: 100, // Start animation earlier
      easing: "ease-out-cubic", // Smoother easing
      delay: 0, // No delay
      disable: window.innerWidth < 768, // Disable on mobile for better performance
    });

    return () => {
      // Cleanup AOS
      if (animationRef.current) {
        animationRef.current.destroy();
      }
    };
  }, []);

  // Optimized items with useMemo
  const items = useMemo(
    () => [
      {
        tag: "Atlas",
        title: "Incorporate your company",
        description:
          "Form a legal entity, issue stock, and start accepting payments.",
        image: "/images/atlas-ui.png",
        height: 620,
        width: 500,
        btnImg: "/Images/Group(1).png",
        type: translations[language]?.stripeCardTitle,
        types: "first",
        img: "/Images/hoverImage.png",
        sub: translations[language]?.stripeCardDes,
      },
      {
        tag: "Payment Links",
        description:
          "Test your product idea by launching payments with little to no code.",
        image: "/images/qr-ui.png",
        btnImg: "/Images/commomn.png",
        height: 550,
        width: 500,
        type: translations[language]?.commodities,
        types: "second",
        img: "/Images/hoverIamge2.png",
        sub: translations[language]?.stripeCoomDes,
      },
      {
        tag: "Checkout",
        title: "Sell products and services",
        description:
          "Launch a business with a prebuilt payment page that's optimised for conversion.",
        image: "/images/checkout-ui.png",
        height: 550,
        width: 500,
        type: translations[language]?.crypto,
        btnImg: "/Images/Group(1).png",
        types: "third",
        img: "/Images/hoverImage3.png",
        sub: translations[language]?.srtripeThirdDes,
      },
      {
        tag: "Billing",
        title: "Launch any pricing model",
        description:
          "Offer usage-based billing to charge customers based on how much they use.",
        image: "/images/graph-ui.png",
        height: 620,
        width: 500,
        btnImg: "/Images/meteer.png",
        type: translations[language]?.Indices,
        types: "fourth",
        margin: "-68px",
        img: "/Images/hoverImage4.png",
        sub: translations[language]?.stripeFourDesc,
      },
      {
        tag: "Billing",
        title: "Launch any pricing model",
        description:
          "Offer usage-based billing to charge customers based on how much they use.",
        image: "/images/graph-ui.png",
        btnImg: "/Images/energy22.png",
        height: 620,
        width: 500,
        type: translations[language]?.Energies,
        types: "five",
        img: "/Images/hoverImage5.png",
        sub: translations[language]?.stripeFifth,
      },
      {
        tag: "Checkout",
        title: "Sell products and services",
        description:
          "Launch a business with a prebuilt payment page that's optimised for conversion.",
        image: "/images/checkout-ui.png",
        btnImg: "/Images/Stockicons.png",
        height: 550,
        width: 500,
        type: translations[language]?.Stocks,
        types: "six",
        img: "/Images/hoverImage6.png",
        sub: translations[language]?.stripeSixth,
      },
    ],
    [translations, language]
  );

  const [data, setData] = useState(market);

  // Optimized WebSocket with throttling
  useEffect(() => {
    if (webSocketRef.current) {
      webSocketRef.current.close();
    }

    const ws = new WebSocket(
      "wss://websocket-website.cfifinancial.com:2053/prices?ApiKey=9djd82jd0_s62hs71kd06xj27&Symbols=AUDNZD,AUDCAD,AUDCHF,AUDJPY,CHFJPY,EURGBP,EURAUD,EURCHF,EURJPY,EURNZD,EURCAD,GBPCHF,AAL.OQ,AAPL.OQ,AMZN.OQ,ANGH.OQ,BABA.N,GOOGL.OQ,IBM.N,INTC.OQ,KO.N,LCID.OQ,META.OQ,MSFT.OQ,NFLX.OQ,NIO.N,NVDA.OQ,PYPL.OQ,SNAP.N,TSLA.OQ,XAUAUD_,XAUEUR_,XAUGBP_,XAUUSD_,XAGEUR_,XAGUSD_,XAUAUD,XAUEUR,XAUGBP,XAUUSD,XAGEUR,XAGUSD,NatGas_SPOT,BRENT,WTI,CAC40_SPOT,CH20_SPOT,EUR50_SPOT,GER30_SPOT,IBEX35_SPOT,IT40_SPOT,NL25_SPOT,NO25_SPOT,UK100_SPOT,AUS200_SPOT,CA60_SPOT,HKD50_SPOT,AAA,AAAU,AADR,AAPB,AAPD,AAPU,ABEQ,ACES,ACIO,ACTV,ACVF,ACWV,ADAUSD,BCHUSD,BTCUSD,DOGUSD,ETHUSD,SOLUSD,TRXUSD,XRPUSD,BAXM4,FEIM4,FLGU4,LCCN4,CCU4,KC0724,HGCN4,CTZ4,NatGas_N4,NatGas_Q4,USOIL_N4,UKOIL_Q4,PL0724,ZS0724"
    );

    ws.onopen = () => {
      console.log("WebSocket Connected");
    };

    // Throttled message handler for better performance
    const throttledMessageHandler = throttle((event) => {
      try {
        const data = JSON.parse(event.data);
        setData((prevData) => {
          return {
            ...prevData,
            ["Forex"]: prevData?.["Forex"]?.map((item) =>
              item.symbol === data.Symbol
                ? {
                  ...item,
                  price: data?.Bid?.toFixed(4),
                  Change: data?.DayChange?.toFixed(4),
                }
                : item
            ),
          };
        });
      } catch (error) {
        console.error("Error parsing WebSocket data:", error);
      }
    }, 100); // Throttle to 100ms

    ws.onmessage = throttledMessageHandler;

    ws.onclose = () => {
      console.log("WebSocket Disconnected. Attempting to reconnect...");
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    webSocketRef.current = ws;

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, []);

  const [dataCommon, setDataComom] = useState(market);
  // console.log("dfds55555",dataCommon);
  // useEffect(() => {
  //   const ws = new WebSocket(
  //     "wss://websocket-website.cfifinancial.com:2053/prices?ApiKey=9djd82jd0_s62hs71kd06xj27&Symbols=AUDNZD,AUDCAD,AUDCHF,AUDJPY,CHFJPY,EURGBP,EURAUD,EURCHF,EURJPY,EURNZD,EURCAD,GBPCHF,AAL.OQ,AAPL.OQ,AMZN.OQ,ANGH.OQ,BABA.N,GOOGL.OQ,IBM.N,INTC.OQ,KO.N,LCID.OQ,META.OQ,MSFT.OQ,NFLX.OQ,NIO.N,NVDA.OQ,PYPL.OQ,SNAP.N,TSLA.OQ,XAUAUD_,XAUEUR_,XAUGBP_,XAUUSD_,XAGEUR_,XAGUSD_,XAUAUD,XAUEUR,XAUGBP,XAUUSD,XAGEUR,XAGUSD,NatGas_SPOT,BRENT,WTI,CAC40_SPOT,CH20_SPOT,EUR50_SPOT,GER30_SPOT,IBEX35_SPOT,IT40_SPOT,NL25_SPOT,NO25_SPOT,UK100_SPOT,AUS200_SPOT,CA60_SPOT,HKD50_SPOT,AAA,AAAU,AADR,AAPB,AAPD,AAPU,ABEQ,ACES,ACIO,ACTV,ACVF,ACWV,ADAUSD,BCHUSD,BTCUSD,DOGUSD,ETHUSD,SOLUSD,TRXUSD,XRPUSD,BAXM4,FEIM4,FLGU4,LCCN4,CCU4,KC0724,HGCN4,CTZ4,NatGas_N4,NatGas_Q4,USOIL_N4,UKOIL_Q4,PL0724,ZS0724"
  //   );

  //   ws.onopen = () => {
  //     console.log("WebSocket Connected");
  //   };

  //   ws.onmessage = (event) => {
  //     try {
  //       const data = JSON.parse(event.data);
  //       setDataComom((prevData) => {
  //         return {
  //           ...prevData,
  //           ["Commodities"]: prevData?.["Commodities"]?.map((item) =>
  //             item.symbol === data.Symbol
  //               ? {
  //                   ...item,
  //                   price: data?.Bid?.toFixed(4),
  //                   Change: data?.DayChange?.toFixed(4),
  //                 }
  //               : item
  //           ),
  //         };
  //       });
  //     } catch (error) {
  //       console.error("Error parsing WebSocket data:", error);
  //     }
  //   };

  //   ws.onclose = () => {
  //     console.log("WebSocket Disconnected. Attempting to reconnect...");
  //   };

  //   ws.onerror = (error) => {
  //     console.error("WebSocket Error:", error);
  //   };

  //   return () => {
  //     ws.close();
  //   };
  // }, []);

  // first card data

  const baseHeights = useMemo(
    () => ({
      Forex: 350,
      Stocks: 280,
      Crypto: 280,
      Indices: 350,
      Energies: 350,
    }),
    []
  );




  const getCoinDataByType = useCallback((type) => {
    switch (type) {
      case "Forex":
        return coinData;
      case "Commodities":
        return coinData2;
      case "Crypto":
        return coinDatas3;
      case "Indices":
        return coinDatas5;
      case "Energies":
        return coinDatas6;
      case "Stocks":
        return coinDatass7;
      // Add more cases as needed
      default:
        return [];
    }
  }, []);

  // Second card data

  const getCoinDataByTypeSecond = useCallback((type) => {
    switch (type) {
      case "Forex":
        return coinData1;
      case "Commodities":
        return coinDatas2;
      case "Crypto":
        return coinDatass3;
      case "Indices":
        return coinDatass5;
      case "Energies":
        return coinDatass6;
      case "Stocks":
        return coinDatassS7

      default:
        return [];
    }
  }, []);

  // Optimized hover handlers
  const handleMouseEnter = useCallback((index) => {
    setHoveredIndex(index);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoveredIndex(null);
  }, []);

  return (
    <Box
      mt={8}
      sx={{
        backgroundColor: "#F6F9FC",
        px: { xs: 4, md: 6 },
        py: 8,
        // Performance optimizations
        willChange: "auto",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
      }}
    >
      <Box px={{ xs: 2, sm: 3, md: 6, lg: 4.5 }} mx="auto" mt={4} mb={8}>
        <Typography
          data-aos="fade-up"
          variant="body2"
          sx={{
            color: "#2494C9",
            fontSize: "20px",
            fontWeight: "700",
            textAlign: { xs: "center", md: "center" },
          }}
        >
          {translations[language]?.Discover?.title}
        </Typography>
        <Box textAlign="center" mt={2}>
          <Typography
            variant="h2"
            data-aos="fade-up"
            fontWeight={"600"}
            sx={{ textAlign: { xs: "center", md: "center" } }}
          >
            {translations[language]?.Discover?.subtitle}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>

            <Typography
              data-aos="fade-up"
              sx={{
                fontSize: "20px",
                textAlign: { xs: "center", md: "center" },
                color: "rgba(102, 112, 133, 1)",
                fontWeight: "400",
                fontFamily: "SF Pro Display",
                mt: 1.5,
                width: { xs: "100%", md: "780px" },
              }}
            >
              {translations[language]?.Discover?.description}
              <Box component="br" sx={{ display: { xs: "none", md: "block" } }} />
              {translations[language]?.Discover?.description1},
              <Box component="br" sx={{ display: { xs: "none", md: "block" } }} />
              {translations[language]?.Discover?.description2}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Grid Cards */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // Performance optimizations
          willChange: "auto",
        }}
      >
        <Grid
          container
          spacing={3}
          justifyContent="center"
          maxWidth="1300px"
          mx="auto"
        >
          {items?.map((item, index) => {
            const isHovered = hoveredIndex === index;
            const baseHeight = baseHeights[item?.type] ?? 280;
            const dynamicHeight = `${baseHeight - (isHovered ? 42 : 0)}px`;

            return (
              <Grid key={index} item xs={12} md={6}>
                <Card
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                  sx={{
                    borderRadius: 3,
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "450px",
                      lg: item.width,
                    },
                    height: item.height,
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "none",
                    marginTop: { md: item?.margin },
                    cursor: "pointer",
                    // Optimized transitions
                    transition: "transform 0.2s ease-out",
                    willChange: "transform",
                    transform: "translateZ(0)",
                    backfaceVisibility: "hidden",
                    "&:hover": {
                      transform: "translateZ(0) translateY(-2px)",
                      boxShadow: "none",
                    },
                  }}
                >
                  {/* Main visible content */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      // Performance optimizations
                      willChange: "auto",
                    }}
                  >
                    <CoinSlider
                      coinData={getCoinDataByType(item?.type)}
                      coinData1={getCoinDataByTypeSecond(item?.type)}
                      buttonImage={item?.btnImg ?? "/Images/Group(1).png"}
                      title={item?.type}
                      type={item?.types}
                      hovered={isHovered}
                      subtitle={item?.sub}
                      index={index}
                      imageUrl={item?.img ?? "/Images/hoverImage.png"}
                      dynamicHeight={dynamicHeight}
                    />
                  </Box>

                  {/* Expanding section */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 25,
                      left: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      overflow: "hidden",
                      px: "28px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      zIndex: 1,
                      willChange: "transform, opacity",
                    }}
                  >
                    <Box
                      sx={{
                        // Always visible on xs; animate on hover for md+
                        opacity: {
                          xs: 1,
                          md: isHovered ? 1 : 0,
                        },
                        transform: {
                          xs: "translateY(0)",
                          md: isHovered ? "translateY(0)" : "translateY(20px)",
                        },
                        transition:
                          "opacity 0.2s ease-out, transform 0.2s ease-out",
                        mb: 2,
                        cursor: "pointer",
                        willChange: "transform, opacity",
                      }}
                      onClick={() =>
                        window.open("http://portal.bbcorp.trade/", "_blank")
                      }
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#1976d2",
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          transition: "color 0.2s ease-out",
                          "&:hover": {
                            color: "#1565c0",
                          },
                        }}
                      >
                        {translations[language]?.tradingStripe}
                        <EastIcon
                          sx={{
                            transition: "transform 0.2s ease-out",
                            transform: {
                              xs: "translateX(4px)",
                              md: isHovered
                                ? "translateX(4px)"
                                : "translateX(0)",
                            },
                          }}
                        />
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
    // </Container>
  );
};
